export default __webpack_public_path__ + "static/media/building.04a98d4a.svg";